import React, {FC} from 'react';

import {OnboardingGuideTask, OnboardingGuideTaskRequiredProps} from '../../onboardingGuideTask';
import {inboxTaskDescription, inboxTaskTitle} from './adminOnboardingText';

/*
 * Component.
 */

export const CreateInboxTask: FC<OnboardingGuideTaskRequiredProps> = ({isComplete = false, onClick}) => (
  <OnboardingGuideTask
    title={inboxTaskTitle}
    isComplete={isComplete}
    onClick={onClick}
    icon="inboxFilled"
    description={inboxTaskDescription}
  />
);
